<div #modalHeader class="app-modal-header">
  <div #modalTitleButtons class="modal-title-buttons">
    @for (btn of titleButtons; track $index) {
      <button type="button" class="btn btn-icon-only" (click)="btn.action()">
        <svg-icon [key]="btn.icon" size="lg" [tooltip]="btn.tooltip" />
      </button>
    }
    @if (showSpinner) {
      <mat-spinner class="spinner-button" />
    } @else {
      <button type="button" class="btn btn-icon-only" (click)="close()">
        <svg-icon key="close" />
      </button>
    }
  </div>
  <div class="modal-header-container">
    @if (modalTitle) {
      <h3>
        @if (modalIcon) {
          <svg-icon [key]="modalIcon" size="lg" class="m-r-8" style="vertical-align: text-bottom" />
        }
        {{ modalTitle }}
      </h3>
    }
    <ng-content #customHeaderContent select="[modalHeader]"></ng-content>
  </div>
</div>
<div class="app-modal-body scrollable-content" [ngClass]="modalClass">
  <ng-content select="[modalBody]"></ng-content>
</div>
@if (showFooter) {
  <div class="app-modal-footer">
    <ng-content select="[modalFooter]"></ng-content>
  </div>
}
